/**
 * 题目查看demo
 * @description 多种题型demo查看的demo
 * @author mll
 * @date 2020-1-21
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool } from '../../../tool'
let { WizCard, WizButton, WizModal } = component_tool;
let { WizContainer } = framework_tool;
import { ShowSubject as ShowSubjectComponent } from '../../../components'

class ShowSubject extends WizContainer {

    componentName = 'ShowSubject';

    constructor(props) {
        super(props);
        this.state = {
            visable: false,
            subjectProps: {}
        }
    }

    _onClick = (title) => {
        this.setState({
            subject: title,
            visable: !this.state.visable
        })
    }

    _card = (title, icon = '0') => {
        return (
            <WizCard title={title} icon={icon}>
                <WizButton onClick={() => { this._onClick(title) }}>查看题目</WizButton>
            </WizCard>
        )
    }

    _modal() {
        let { visable, subject } = this.state
        let title = '查看题目 - ' + subject
        let subjectProps = {}
        if (subject === '单选题' || subject === '多选题') {
            subjectProps = {
                title: '蚂蚁的企业级产品是一个庞大且复杂的体系。这类产品不仅量级巨大且功能复杂，而且变动和并发频繁，常常需要设计与开发能够快速的做出响应。同时这类产品中有存在很多类似的页面以及组件，可以通过抽象得到一些稳定且高复用性的内容。随着商业化的趋势，越来越多的企业级产品对更好的用户体验有了进一步的要求。带着这样的一个终极目标，我们（蚂蚁金服体验技术部）经过大量的项目实践和总结，逐步打磨出一个服务于企业级产品的设计体系 Ant Design。基于『确定』和『自然』的设计价值观，通过模块化的解决方案，降低冗余的生产成本，让设计者专注于更好的用户体验。',
                titleImage: { src: 'https://www.w3school.com.cn/i/eg_tulip.jpg', style: { height: 180, width: 300 } },
                options: [
                    { title: 'A、🐲龙', imgUrl: 'http://img.pcgames.com.cn/images/upload/upc/tx/gamephotolib/1607/05/c0/15705680_1467708502461_medium.jpg' },
                    { title: 'B、🏠房子', imgUrl: 'http://t8.baidu.com/it/u=2247852322,986532796&fm=79&app=86&f=JPEG?w=1280&h=853' },
                    { title: 'C、👨特朗普vs通贝里,如果我的一个选项很长超出一行的距离后该如何展示呢？如果我的一个选项很长超出一行的距离后该如何展示呢？如果我的一个选项很长超出一行的距离后该如何展示呢？如果我的一个选项很长超出一行的距离后该如何展示呢？如果我的一个选项很长超出一行的距离后该如何展示呢？', imgUrl: 'https://pic.rmb.bdstatic.com/a95ca819235bfb5aecdc14ab97e786451861.gif' },
                    { title: 'D、🦁️狮子', imgUrl: 'http://t8.baidu.com/it/u=1484500186,1503043093&fm=79&app=86&f=JPEG?w=1280&h=853' }
                ],
                answer: 'A',
                analysis: '中国人应该选龙'
            }
        } else if (subject === '判断题') {
            subjectProps = {
                title: '判断题是一种以对或错来选择的答案。判断题是一种以对或错来选择的答案。一般表现为出一句话，然后在后面的括号内打上“√”或“×”。',
                options: [
                    { title: ' ⭕️ 对' },
                    { title: ' ❌ 错' },
                ],
                answer: ' ⭕️ 对',
                analysis: '详见百度百科'
            }
        } else if (subject === '主观题') {
            subjectProps = {
                title: '什么是客观题?什么是主观题?',
                titleImage: { src: 'https://iknow-pic.cdn.bcebos.com/4b90f603738da9775066221fbd51f8198618e3bd?x-bce-process=image/resize,m_lfit,w_600,h_800,limit_1' },
                answer: '主观题是:有多种回答都可以的,如简答题',
                analysis: '主观性试题有:问答题\案例题\计算题等'
            }
        }
        else if (subject === '填空题') {
            subjectProps = {
                title: 'React 使创建交互式 UI 变得轻而易举。为你应用的每一个_____设计简洁的视图，当数据改变时 React 能有效地更新并正确地_____组件。',
                titleImage: {
                    src: 'https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=1658603858,686533857&fm=26&gp=0.jpg',
                    style: { height: 300, width: 300 }
                },
                answer: '状态, 渲染',
                analysis: 'React基础'
            }
        }
        return (
            <WizModal
                visible={visable}
                cancelButtonProps={{ style: { height: 0, width: 0 } }}
                style={{ minWidth: 700 }}
                title={title}
                onCancel={() => this.setState({ visable: false })}
                footer={<WizButton onClick={() => this.setState({ visable: false })}>关 闭</WizButton>}
            >
                <ShowSubjectComponent key={subject} {...subjectProps} />
            </WizModal>
        )
    }

    render() {
        log.info('subject:', this.state.subject)
        return (
            <>
                {this._card('单选题')}
                {this._card('多选题')}
                {this._card('判断题')}
                {this._card('主观题')}
                {this._card('填空题')}
                {this._modal()}
            </>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {

    };
};

export default connect(mapStateToProps)(ShowSubject);
